import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CombosConfiguration } from 'brainloper-ui';
import { InputOrOutputInventory } from 'src/app/models/inventory/input-or-output-inventory';
import { Item } from 'src/app/models/inventory/item';
import { Warehouse } from 'src/app/models/inventory/warehouse';

export interface HandlerItemsRowConfig {
  fromPackOff: boolean;
  comboDataWarehouse: Warehouse[];
  comboItemsByWarehouse: any;
  comboDataItems: Item[];
  view: boolean;
  addRentalOrder: boolean;
  addNewItem: boolean;
  showAmount: boolean;
  isMobile: boolean;
  showCurrentAmount: boolean;
  editCostItem: boolean;
  labelCodigo: string;
  showUnitMeasurement: boolean;
  showDeleteItem: boolean;
  itemsDataLength: number;
}

@Component({
  selector: 'app-handler-items-row',
  templateUrl: './handler-items-row.component.html',
  styleUrls: ['./handler-items-row.component.scss'],
  standalone: false
})
export class HandlerItemsRowComponent implements OnInit, OnChanges {
  @Input() config: HandlerItemsRowConfig;
  @Input() element: InputOrOutputInventory;
  @Input() reloadItemVersion: number = 0;

  @Output() onValueWarehouseByItem = new EventEmitter<Warehouse>();
  @Output() onValueIDItem = new EventEmitter<number>();
  @Output() onAddNew = new EventEmitter<string>();
  @Output() onKeyUpAmout = new EventEmitter<void>();
  @Output() onDeleteItemsData = new EventEmitter<void>();

  public comboConfigItem: CombosConfiguration;
  public reloadComboItem = new EventEmitter<any>();
  public comboConfigWarehouseByItem: CombosConfiguration;
  public reloadComboWarehouseByItem = new EventEmitter<any>();

  private _prevItemInventoryId: number;
  private _prevWarehouseId: number;
  private _prevReloadItemVersion: number;

  ngOnInit() {
    this.comboConfigItem = {
      visibleField: 'itemName',
      selectionField: 'id',
      label: 'Item',
      selected: this.element?.itemInventoryId ?? null,
    };
    this.comboConfigWarehouseByItem = {
      visibleField: 'name',
      selectionField: 'id',
      label: 'Bodega',
      selected: this.element?.warehouseId ?? null,
    };
    this._prevItemInventoryId = this.element?.itemInventoryId;
    this._prevWarehouseId = this.element?.warehouseId;
    this._prevReloadItemVersion = this.reloadItemVersion;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.comboConfigItem) return;

    if (changes['element'] && this.element) {
      if (this.element.itemInventoryId !== this._prevItemInventoryId) {
        this._prevItemInventoryId = this.element.itemInventoryId;
        this.comboConfigItem = { ...this.comboConfigItem, selected: this.element.itemInventoryId ?? null };
        this.reloadComboItem.emit('selected');
      }
      if (this.config?.fromPackOff && this.element.warehouseId !== this._prevWarehouseId) {
        this._prevWarehouseId = this.element.warehouseId;
        this.comboConfigWarehouseByItem = { ...this.comboConfigWarehouseByItem, selected: this.element.warehouseId ?? null };
        this.reloadComboWarehouseByItem.emit('selected');
      }
    }

    if (changes['reloadItemVersion'] &&
        !changes['reloadItemVersion'].isFirstChange() &&
        this.reloadItemVersion !== this._prevReloadItemVersion) {
      this._prevReloadItemVersion = this.reloadItemVersion;
      this.comboConfigItem = { ...this.comboConfigItem, selected: null };
      this.reloadComboItem.emit();
    }
  }

  valueWarehouseByItem(event: Warehouse) { this.onValueWarehouseByItem.emit(event); }
  valueIDItem(event: number) { this.onValueIDItem.emit(event); }
  addNew(type: string) { this.onAddNew.emit(type); }
  keyUpAmout() { this.onKeyUpAmout.emit(); }
  deleteItemsData() { this.onDeleteItemsData.emit(); }
}
